export const LINKS = [
  {
    name: 'Contacts',
    href: '/contact',
  },
  {
    name: 'Guarantees',
    href: '/guarantees',
  },
  {
    name: 'About',
    href: '/about',
  },
  {
    name: 'Return Terms',
    href: '/terms',
  },
  {
    name: 'Service Agreement',
    href: '/service-agreement',
  },
];
